import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr9 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        за безопасна работа с ръчни механични инструменти
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. До работа с ръчни инструменти </b>се допускат лица, които са преминали всички видове
        инструктажи за безопасна работа и са се запознали с настоящата инструкция.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Преди започване на работа </b>с ръчни механични инструменти служителят е длъжен да
        провери изправността на инструментите.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Дръжките на ръчните механични инструменти </b>да имат гладка повърхност, да не са
        побити и да са изработени от твърд и жилав дървен материал или подходяща пластмаса.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. Инструментите със заострени краища</b> за набиване на дръжки, като пили, ножовки и
        др., да имат дръжки, съответстващи на размерите им с бандажни пръстени.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5. Чуковете да имат леко изпъкнало (сферично) чело</b>, да не са подбити или изкривени,
        да нямат пукнатини и наклев, и да са здраво закрепени към дръжките.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. Ударните ръчни механични инструменти</b>, като центри, пробойници и секачи, да бъдат
        без пукнатини, отчупвания и повреди.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. При работа с ударни инструменти</b>, при които ножовете могат да отхвръкнат отрязана
        или отчупена част, работниците задължително трябва да работят с предпазни очила.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8. При работа с ръчни ножовки или пили</b>, ръката да не се държи в близост до работната
        плоскост, а обработваните детайли да бъдат здраво стегнати.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9. Използваните гаечни ключове </b>да съответстват на гайките и на болтовите глави, да не
        са пукнати, разширени, да нямат отчупени части; сглобяемите ключове да бъдат здрави в
        подвижните си челюсти.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. Остриетата на отверките</b> да бъдат с дебелина, осигуряваща плътното влизане в
        прорезите на винтовете. За различните по ширина прорези на винтовете да се ползват различни
        отверки.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. Закрепителните инструменти</b>, като менгемета, стеги, наковални и приспособления за
        огъване на тръби и шини, да се закрепват здраво към шлосерската маса или към пода.
      </Typography>

      <Typography>
        <span style={styles.warning}>12. ЗАБРАНЯВА СЕ:</span>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се работи с неизправни, изхабени и несъответстващи на работата ръчни механични
          инструменти;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - използване на инструменти не по предназначение;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се правят дръжки на механични инструменти от суров материал, хвойна или други крехки
          дървени материали;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се работи с пили, ножовки и др. подобни инструменти без дръжки;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се реже само към себе си, когато се използват режещи инструменти;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - работа с обемисти ръкавици;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - хвърляне на инструменти;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - носене на остри инструменти в джобове на работно облекло;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се използват несъответстващи по размер или повредени гаечни ключове чрез
          приспособяване на метални пластинки или отвертки между гайките и ключа;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се удължават рамената на ключовете с тръби и други предмети.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>13. При използване на преносими стълби </b>ръчните инструменти да не се оставят на
        стъпалата на стълбите.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>14. При работа на височина чрез въжета</b> необходимите за работа инструментида са
        прикачени към колана или към седалката.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>15. Работната зона да се поддържа чиста и подредена</b>, без да се разхвърлят безразборно
        инструменти, които могат да причинят инциденти.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>16. След приключване на покривни работи</b> ръчните инструменти да се свалят от покрива.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr9;
